import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { debounce } from "lodash";
import { useImageSrc, useThemeSwitch } from "../../hooks";
import { IMAGES } from "../../themes";
import Button from "../Button";
import { noop } from "../../utils/function";
const useStyles = makeStyles(({
  typography,
  breakpoints
}) => ({
  button: {
    paddingLeft: 0,
    paddingRight: 0,
    boxShadow: "none",
    "&:hover": {
      background: "none"
    }
  },
  image: {
    height: typography.pxToRem(30),
    [breakpoints.down("xs")]: {
      height: typography.pxToRem(24)
    }
  }
}));

const ThemeSwitcher = ({
  onSwitch
}) => {
  const bannerImageSrc = useImageSrc(IMAGES.SWITCH_COLOR);
  const styles = useStyles();
  const switchTheme = useThemeSwitch();
  const onClick = React.useCallback(debounce(() => {
    const currentTheme = switchTheme();
    onSwitch(currentTheme);
  }, 400), [onSwitch, switchTheme]);
  return /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    disableRipple: true,
    disableFocusRipple: true,
    className: styles.button,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.image,
    src: bannerImageSrc,
    alt: ""
  }));
};

ThemeSwitcher.propTypes = {
  onSwitch: PropTypes.func
};
ThemeSwitcher.defaultProps = {
  onSwitch: noop
};
export default ThemeSwitcher;